import clx from "classnames";
export default function AppTextArea({ value, onChange, className, ...props }) {
  return <textarea value={value} onChange={(event) => onChange(event.target.value)} className={clx("form h-20", className)} {...props} />;
}
